import { useEffect, useState } from 'react';
import { AccountSiteSelect } from '../../../components/AccountSiteSelect';
import { ChangeEvent } from 'react';
import { SupportCreateTicket } from '../../../types/commonTypes';
import { useOperator } from '../../../contexts/OperatorContext';
import { Input } from '../../../components/Input';
import clsx from 'clsx';

interface Props {
  ticketFields: SupportCreateTicket;
  updateFormField(key: keyof SupportCreateTicket, value: any): void;
  loading: boolean;
  onChange(event: ChangeEvent<HTMLInputElement>): void;
}

export const SubjectSiteFields = ({
  ticketFields,
  loading,
  onChange,
  updateFormField,
}: Props) => {
  const [selectedSite, setSelectedSite] = useState('');
  const operator = useOperator();
  const multiSite =
    operator.type === 'Hospitality' && (operator.sites?.length ?? 0) > 1;

  useEffect(() => {
    updateFormField('site', selectedSite);
  }, [selectedSite]);

  return (
    <div className="grid grid-cols-12 item-end">
      <Input
        name="subject"
        className={clsx('col-span-full', { 'sm:col-span-8': multiSite })}
        placeholder="Subject"
        helperText="*Required"
        autoFocus
        required
        fullWidth
        value={ticketFields.subject}
        onChange={onChange}
        variant="contained"
        disabled={loading}
      />
      {multiSite ? (
        <AccountSiteSelect
          className="col-span-full sm:col-span-4 items-stretch"
          listAll={true}
          onSelect={setSelectedSite}
          isRequired
          disabled={loading}
        />
      ) : null}
    </div>
  );
};
